export enum UserServiceErrors {
  EmailOrToken = 'WRONG_EMAIL_OR_TOKEN',
  EmailExists = 'EMAIL_ALREADY_EXISTS',
  ReqParamsMissing = 'REQUEST_PARAMETERS_MISSING',
  Unauthorized = 'UNAUTHORIZED'
}